import styled from 'styled-components'

export const Container = styled.section`
  padding-top: 120px;
  .features-content{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    box-sizing: border-box;
    width: calc(100% + 32px);
    margin: -16px;
    margin-top: 32px;
  }
`
